import React from "react";
import { Dialog } from "primereact/dialog";
import styled from "styled-components";
import { Button } from "primereact/button";
import FileUploadField from "../components/fileUploadField";
import { useTranslation } from "react-i18next";
import { report } from "process";
import useImportProductsFromExcel from "../hooks/useImportProductsFromExcel";

const DialogActions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 2rem;
`;

interface ImportProductsDialogProps {
  show: boolean;
  onHide: () => void;
  onAccept: () => void;
  reportId?: number;
  onImportComplete?: () => void;
}

const ImportProductsDialog: React.FC<ImportProductsDialogProps> = ({
  show,
  onHide,
  onAccept,
  reportId,
  onImportComplete,
}) => {
  const { t } = useTranslation();

  const { postProductExcel } = useImportProductsFromExcel();

  return (
    <Dialog visible={show} style={{ width: "600px" }} onHide={onHide}>
      <FileUploadField
        existingReportId={reportId}
        postProductExcel={postProductExcel}
        onImportComplete={onImportComplete}
      />
      <DialogActions>
        <Button
          type="button"
          label={t("cmd-close")}
          className="p-button-text"
          onClick={onHide}
          outlined
        />
        <Button
          type="button"
          label={t("cmd-save")}
          className="p-button-primary"
          onClick={onAccept}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ImportProductsDialog;
